import { render, staticRenderFns } from "./ColorsChangeColorSSR.vue?vue&type=template&id=769d67d5&"
import script from "./ColorsChangeColorSSR.vue?vue&type=script&lang=js&"
export * from "./ColorsChangeColorSSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports